import type { ParseHeight } from "./types";

// A German estimator types "1,5"; anything not a plain non-negative number is no height.
export const parseHeight: ParseHeight = (text) => {
  const normalised = text.trim().replace(",", ".");
  if (!/^\d+(\.\d+)?$/.test(normalised)) return null;
  return Number(normalised);
};
